import {ComponentRegistry} from '../../components/component-registry';
import {DataApi} from '../../api/data-api/data-api';
import {AbstractGroup} from '../abstract-group';
import {LawyerFilter, LawyerSettings} from './filter';

/**
 * Lawyer picker.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class Picker extends AbstractGroup<LawyerFilter, LawyerSettings> {
  constructor(container: HTMLElement) {
    super(container);
    this.find();
    ComponentRegistry.add('lawyer-picker', this);
  }

  /**
   * Finds picked lawyers.
   */
  protected find(): void {
    DataApi.instance.lawyerEndpoint.find(this.settings, null)
      .then(response => {
        if (this.isResultEmpty(response)) {
          this.empty();
          return;
        }
        this.notEmpty();

        let html = '';
        let i = 0;
        for (const document of response.documents) {
          const template = require('../../handlebars/templates/lawyer/item.handlebars');
          html += template({
            document: document,
            isLast: i === response.documents.length - 1,
            iteration: i++,
            itemClass: 'col-12 mb-5',
            hidePosition: true
          });
        }
        this.update(html);

        this.emitter.emit('change', this);
      })
      .catch(e => {
        this.error(e);
      });
  }
}
